if (document.querySelector(".js-prod-desc-accordions")) {
  const all_desc_accordions = Array.from(
    document.querySelectorAll(".js-acc-tab")
  );
  all_desc_accordions.forEach((accordion) => {
    const title = accordion.querySelector(".js-acc-tab-title");
    const body = accordion.querySelector(".js-acc-tab-body");
    let initialHeight = title.offsetHeight;
    let bodyHeight = body.scrollHeight;
    let realHeight = initialHeight + bodyHeight;

    accordion.style.height = initialHeight + "px";
    body.style.height = "unset";

    title.addEventListener("click", () => {
      initialHeight = title.offsetHeight;
      bodyHeight = body.scrollHeight;
      realHeight = initialHeight + bodyHeight;

      accordion.style.height = initialHeight + "px";
      body.style.height = "unset";

      if (accordion.getAttribute("data-open")) {
        accordion.removeAttribute("data-open");
        accordion.style.height = `${initialHeight}px`;
        title.classList.remove("--open");
      } else {
        accordion.setAttribute("data-open", true);
        accordion.style.height = `${realHeight}px`;
        title.classList.add("--open");
      }
    });
  });
}

setTimeout(() => {
  let review_tab_title = document.querySelector('#review-tab-title')
  if(review_tab_title){
    review_tab_title.click();
  }
},3000)

class CustomGallery extends HTMLElement {
  constructor() {
    super();

    this.Swiper = window.Swiper || null;
    if (this.Swiper) {
      this.el = this.querySelector(".js-mob-gallery-swiper");
      this.pagination = this.querySelector(".js-swiper-pagination");
      this.thumbs = this.querySelector(".js-mob-gallery-swiper-thumbs");
      this.slides = this.el.querySelectorAll('.swiper-slide');
      this.thumbsSwiper = null;

      if (this.thumbs) {
        const prev = this.querySelector(".js-swiper-button-prev");
        const next = this.querySelector(".js-swiper-button-next");
        this.thumbsSwiper = new this.Swiper(this.thumbs, {
          spaceBetween: 5,
          slidesPerView: 4,
          freeMode: false,
          watchSlidesProgress: true,
          navigation: { prevEl: prev, nextEl: next },
        });
        this.thumbsSwiper.on('slideChange', () => {
          // Update the main slider to match the thumb slider's active slide
          this.mainSlider.slideTo(this.thumbsSwiper.activeIndex);
        });
      }

      const config = {
        loop: false,
        effect: "slide",
        thumbs: this.thumbsSwiper
          ? {
              swiper: this.thumbsSwiper,
            }
          : null,
      };

      if (!this.thumbsSwiper && this.pagination) {
        config.pagination = { el: this.pagination };
      }

      this.mainSlider = new this.Swiper(this.el, config);
      // Add event listener for variant selected
      window.addEventListener("variantselected", (event) => {
        this.slides.forEach((slide, index) => {
          if (slide.querySelector('.product-media-item img')?.dataset.imageId == event.detail) {
            this.mainSlider.slideTo(index, 500, true);
          }
        });
      });
    }
  }
}

customElements.define("custom-gallery", CustomGallery);